import { useQuery, UseQueryOptions } from 'react-query';

import { ActiveDataRoomLender, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useActiveDataRoomLendersQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<ActiveDataRoomLender[], unknown, ActiveDataRoomLender[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.ActiveDataRoomLenders(guid),
		() =>
			AxiosUtils.getResponseData<ActiveDataRoomLender[]>(
				api.get(CerebroApiEndpoints.Lookups.ActiveDataRoomLenders(guid))
			),
		options
	);
}
